import React from 'react';
import '../../styles/common.css';
import styles from './Contacts.module.css';

const Contacts = () => {
  return (
    <section className={styles.contactsSection}>
      <div className="container">
        <h1 className="title">Контакты</h1>
      </div>

      <main className={`container contentBlock ${styles.contactsPage}`}>
        <p className="lead">Связаться с нами можно через: </p>

        <section style={{marginTop: '1rem'}}>
          <p>
            Telegram: <a href="https://t.me/interworld_support_bot" target="_blank" rel="noreferrer">@interworld_support_bot</a>
          </p>
          <p>
            Почта: <a href="mailto:support@interworld.fun">support@interworld.fun</a>
          </p>
          <p>
            Дискорд: <a href="https://discord.gg/7CVSZpfYNp" target="_blank" rel="noreferrer">https://discord.gg/7CVSZpfYNp</a>
          </p>
        </section>
      </main>
    </section>
  );
};

export default Contacts;
